import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BSButton from 'react-bootstrap/Button';
import FileSize from '../display/FileSize';
export const DownloadButton = (props) => {
    let { variant, size, block, onClick = () => { } } = props;
    const { t } = useTranslation();
    return (React.createElement(BSButton, { variant: variant, size: 'xl', block: block, onClick: () => onClick() },
        React.createElement("i", { className: "fa fa-download fa-fw" }),
        React.createElement("span", { className: "ml-2" }, t('download')),
        React.createElement("small", { className: "ml-2" },
            "(",
            React.createElement(FileSize, { documentSizeBytes: size }),
            ")")));
};
DownloadButton.propTypes = {
    size: PropTypes.string,
};
DownloadButton.displayName = 'DownloadButton';
